import React, { useMemo } from "react";
import useSeverityAsPriority, {
  SeverityFieldsEnum,
} from "../../../General/useSeverityAsPriority";
import { kebabCase } from "lodash-es";
import {
  normalizeNumbers,
  Table,
  TableCell,
  tableCellTypesEnum,
} from "@SeemplicityDev/shared";
import useAddRef, { UseAddRefOptions } from "../useAddRef";
import { createColumnHelper } from "@tanstack/react-table";

type ResourceCategory =
  | "Machine"
  | "Code"
  | "Cloud"
  | "Container Image"
  | "Runtime Container"
  | "Serverless"
  | "Web"
  | "User"
  | "Other";

interface ResourceCategoryRow {
  name: ResourceCategory;
  resources_count: number;
  severe_count: {
    severity: number;
    count: number;
  };
}

interface ResourcesPageProps extends UseAddRefOptions {
  data?: {
    categories: ResourceCategoryRow[];
  };
  hasTagsPage?: boolean;
}
const ResourcesPage: React.FC<ResourcesPageProps> = ({
  index,
  data,
  addRef,
  hasTagsPage,
}) => {
  const ref = useAddRef({ addRef });
  const { getSeverityField } = useSeverityAsPriority();

  const columnHelper = createColumnHelper<ResourceCategoryRow>();

  const columns = useMemo(() => {
    return [
      columnHelper.accessor("name", {
        cell: (props) => (
          <TableCell type={tableCellTypesEnum.COMPONENT}>
            <div className={"resources-cell"}>
              <i
                className={`seem-icon-resource-${kebabCase(props.getValue())}`}
              />
              {props.getValue()}
            </div>
          </TableCell>
        ),
        enableSorting: false,
        enableColumnFilter: false,
        header: "Name",
        size: 120,
      }),
      columnHelper.accessor("resources_count", {
        cell: (props) => (
          <TableCell>{normalizeNumbers(props.getValue())}</TableCell>
        ),
        enableSorting: false,
        enableColumnFilter: false,
        header: "No. Resources",
        size: 100,
      }),
      columnHelper.accessor("severe_count", {
        cell: (props) => {
          const { severity, count } = props.getValue();
          return (
            <TableCell type={tableCellTypesEnum.COMPONENT}>
              <div className={"findings-count-wrapper"}>
                <div
                  className={"severity-dot"}
                  style={{
                    backgroundColor: getSeverityField(
                      severity,
                      SeverityFieldsEnum.COLOR
                    ),
                  }}
                />
                <span>{normalizeNumbers(count)}</span>
              </div>
            </TableCell>
          );
        },
        enableSorting: false,
        enableColumnFilter: false,
        header: "No. Critical Findings",
      }),
    ];
  }, [data]);

  return (
    <div
      className={`eoy-page resources-page ${hasTagsPage ? "has-tags-page" : ""}`}
      ref={ref}
    >
      <h3>Resources</h3>
      <h4>
        <span className="main">Risk Landscape by Resource Category</span>{" "}
      </h4>
      <div className={"data-container"}>
        <Table
          columns={columns}
          data={data?.categories}
          className={"resources-table"}
        />
      </div>
    </div>
  );
};

export default ResourcesPage;
